import React from 'react'
import { connect } from 'react-redux'
import { func, arrayOf, string } from 'prop-types'
import { debugSettingsType, compositionType, filterType } from 'models/propTypes'

import {
    updateDebugSettings,
    takeScreenshot,
    loseWebglContext,
    setAdmin,
    startSwapTestSaga,
    startLoadTestSaga,
} from 'models/admin/actions'
import { updateSceneManifest } from 'models/scenes/actions'
import { getDebugSettings } from 'models/admin/selectors'
import { getSelectedComposition } from 'models/compositions/selectors'
import { getSubCatalogs, getFilter } from 'models/furniture/selectors'
import { updateFurnitureFilter as updateFurnitureFilterAction } from 'models/furniture/actions'

import Debug from 'components/admin/Debug'

const DebugViewContainer = ({
    debugSettings,
    update,
    composition,
    screenshot,
    loseContext,
    disableAdmin,
    updateManifest,
    subCatalogs,
    furnitureFilter,
    updateFurnitureFilter,
    startSwapTest,
    startLoadTest,
}) => {
    const onManifestUpdate = (...args) => {
        updateManifest(...args)
        // Destroy renderer will be called in PreviewContainer when
        // it gets a new scene because the manifest has changed
    }

    return (
        <Debug
            debugSettings={debugSettings}
            updateDebugSettings={update}
            composition={composition}
            takeScreenshot={screenshot}
            loseWebglContext={loseContext}
            disableAdmin={disableAdmin}
            updateManifest={onManifestUpdate}
            subCatalogs={subCatalogs}
            furnitureFilter={furnitureFilter}
            updateFurnitureFilter={updateFurnitureFilter}
            startSwapTest={startSwapTest}
            startLoadTest={startLoadTest}
        />
    )
}

DebugViewContainer.defaultProps = {
    composition: null,
    subCatalogs: null,
}

DebugViewContainer.propTypes = {
    debugSettings: debugSettingsType.isRequired,
    update: func.isRequired,
    composition: compositionType,
    screenshot: func.isRequired,
    loseContext: func.isRequired,
    disableAdmin: func.isRequired,
    updateManifest: func.isRequired,
    subCatalogs: arrayOf(string),
    furnitureFilter: filterType.isRequired,
    updateFurnitureFilter: func.isRequired,
    startSwapTest: func.isRequired,
    startLoadTest: func.isRequired,
}

const mapStateToProps = (state) => ({
    debugSettings: getDebugSettings(state),
    composition: getSelectedComposition(state),
    subCatalogs: getSubCatalogs(state),
    furnitureFilter: getFilter(state),
})

const mapDispatchToProps = (dispatch) => ({
    update: (ds) => dispatch(updateDebugSettings(ds)),
    screenshot: () => dispatch(takeScreenshot()),
    loseContext: () => dispatch(loseWebglContext()),
    disableAdmin: () => dispatch(setAdmin(false)),
    updateManifest: (...args) => dispatch(updateSceneManifest(...args)),
    updateFurnitureFilter: (...args) => dispatch(updateFurnitureFilterAction(...args)),
    startSwapTest: (...args) => dispatch(startSwapTestSaga(...args)),
    startLoadTest: (...args) => dispatch(startLoadTestSaga(...args)),
})

export default connect(mapStateToProps, mapDispatchToProps)(DebugViewContainer)
